/*
 * Submenu do header: dropdown (desktop) e sanfona (celular).
 * Hover abre o dropdown só por CSS; o clique/teclado usa a classe is-open.
 */
(function () {
  'use strict';

  var DD = '[data-yasy-dd]';

  function fecharDropdowns(exceto, devolverFoco) {
    document.querySelectorAll(DD + '.is-open').forEach(function (dd) {
      if (dd === exceto) return;
      dd.classList.remove('is-open');
      var botao = dd.querySelector('[data-yasy-dd-toggle]');
      if (botao) {
        botao.setAttribute('aria-expanded', 'false');
        if (devolverFoco) botao.focus();
      }
    });
  }

  function alternarDropdown(dd, abrir) {
    var botao = dd.querySelector('[data-yasy-dd-toggle]');
    var vaiAbrir = typeof abrir === 'boolean' ? abrir : !dd.classList.contains('is-open');
    fecharDropdowns(vaiAbrir ? dd : null, false);
    dd.classList.toggle('is-open', vaiAbrir);
    if (botao) botao.setAttribute('aria-expanded', vaiAbrir ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest('[data-yasy-dd-toggle]');
    if (botao) {
      alternarDropdown(botao.closest(DD));
      return;
    }
    var sanfonaBotao = e.target.closest('[data-yasy-acc-toggle]');
    if (sanfonaBotao) {
      var acc = sanfonaBotao.closest('[data-yasy-acc]');
      var aberto = !acc.classList.contains('is-open');
      acc.classList.toggle('is-open', aberto);
      sanfonaBotao.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      return;
    }
    if (!e.target.closest(DD)) fecharDropdowns(null, false);
  });

  document.addEventListener('keydown', function (e) {
    var dd = e.target.closest ? e.target.closest(DD) : null;
    if (e.key === 'Escape') {
      fecharDropdowns(null, !!dd);
      return;
    }
    if (e.key === 'ArrowDown' && dd && e.target.closest('[data-yasy-dd-toggle]')) {
      e.preventDefault();
      alternarDropdown(dd, true);
      var primeiro = dd.querySelector('.yasy-dd__item, .yasy-dd__titulo');
      if (primeiro) primeiro.focus();
    }
  });

  // Foco saindo do item (Tab) fecha o dropdown aberto pelo teclado.
  document.addEventListener('focusout', function (e) {
    var dd = e.target.closest ? e.target.closest(DD) : null;
    if (dd && dd.classList.contains('is-open') && e.relatedTarget && !dd.contains(e.relatedTarget)) {
      alternarDropdown(dd, false);
    }
  });
})();
